/* =============================================================================
   Asakusa — Lecteur Rive partagé

   Pourquoi ce fichier plutôt qu'un <script> par animation :
   le runtime Rive pèse ~400 Ko (WASM). On ne veut ni le charger sur les pages
   qui n'en ont pas besoin, ni l'exécuter plusieurs fois quand il y a plusieurs
   animations sur la même page.

   Fonctionnement :
   1. Ce fichier (~2 Ko) est chargé partout.
   2. S'il ne trouve aucun [data-asa-rive], il ne fait rien de plus.
   3. Sinon il attend qu'une animation approche du viewport, puis charge le
      runtime UNE fois et initialise chaque animation à son tour.
   4. Chaque animation garde son image de repli visible tant qu'elle n'est pas
      prête, puis fait un fondu — jamais de trou dans la page.
   5. Sous `prefers-reduced-motion`, on ne charge rien du tout : l'image de repli
      reste, ce qui est exactement ce que l'utilisateur demande.
   ========================================================================== */
(function () {
  'use strict';

  var nodes = document.querySelectorAll('[data-asa-rive]');
  if (!nodes.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;                       // l'image de repli fait le travail

  var runtimeUrl = document.currentScript && document.currentScript.dataset.runtime;
  var loading = null;

  function loadRuntime() {
    if (window.rive) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = runtimeUrl;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return loading;
  }

  function start(wrap) {
    if (wrap.dataset.riveDone) return;
    wrap.dataset.riveDone = '1';

    var canvas = wrap.querySelector('canvas');
    var src = wrap.dataset.asaRive;
    if (!canvas || !src) return;

    loadRuntime().then(function () {
      try {
        var opts = {
          src: src,
          canvas: canvas,
          autoplay: true,
          onLoad: function () {
            var fit = function () { try { r.resizeDrawingSurfaceToCanvas(); } catch (e) {} };
            requestAnimationFrame(fit);
            setTimeout(fit, 150);
            wrap.classList.add('is-rive-ready');
          }
        };
        var sm = wrap.dataset.riveSm;
        if (sm) opts.stateMachines = sm;
        if (window.rive.Layout && window.rive.Fit) {
          var fitName = wrap.dataset.riveFit === 'contain' ? 'Contain' : 'Cover';
          opts.layout = new window.rive.Layout({
            fit: window.rive.Fit[fitName],
            alignment: window.rive.Alignment.Center
          });
        }
        var r = new window.rive.Rive(opts);

        var ro = window.ResizeObserver ? new ResizeObserver(function () {
          try { r.resizeDrawingSurfaceToCanvas(); } catch (e) {}
        }) : null;
        if (ro) ro.observe(wrap);

        /* Hors écran : on met en pause pour ne pas brûler de batterie */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              try { e.isIntersecting ? r.play() : r.pause(); } catch (err) {}
            });
          }, { threshold: 0 }).observe(wrap);
        }
      } catch (e) {
        /* l'image de repli reste affichée : rien de cassé */
      }
    }).catch(function () { /* idem */ });
  }

  /* Déjà dans (ou près de) l'écran : on démarre tout de suite.
     Le logo du header est au-dessus de la ligne de flottaison — le faire
     dépendre d'un événement de défilement le laisserait figé sur son image. */
  function nearViewport(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.top < h + 200 && r.bottom > -200;
  }

  function sweep() {
    nodes.forEach(function (n) {
      if (!n.dataset.riveDone && nearViewport(n)) start(n);
    });
  }

  /* Plusieurs passages : au chargement du script la mise en page n'est pas
     toujours stabilisée (images, polices), et une animation juste sous la
     ligne de flottaison peut être mal située au premier calcul. */
  sweep();
  window.addEventListener('load', sweep);
  setTimeout(sweep, 400);

  /* Le reste est chargé à l'approche. L'observer est un confort, pas une
     dépendance : un filet de sécurité au défilement prend le relais s'il
     ne se déclenche pas. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        start(e.target);
      });
    }, { rootMargin: '200px' });
    nodes.forEach(function (n) { if (!n.dataset.riveDone) io.observe(n); });
  }

  var pending = true;
  window.addEventListener('scroll', function () {
    if (!pending) return;
    sweep();
    pending = Array.prototype.some.call(nodes, function (n) { return !n.dataset.riveDone; });
  }, { passive: true });
})();
